module.exports = __webpack_public_path__ + "img/roundHook.8c2e6357.svg";